import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../organisms/Header/Header';
import { NoteNavigation } from '../../molecules/NoteNavigation/NoteNavigation';
import { NoteDisplay } from '../../molecules/NoteDisplay/NoteDisplay';
import { NoteForm } from '../../molecules/NoteForm/NoteForm';
import { EditNoteForm } from '../../molecules/EditNoteForm/EditNoteForm';
import { Note } from '../../../types/Note';
import { Button } from '../../atoms/Button/Button';
import { noteService } from '../../../services/noteService';
import './HomePage.css';

export const HomePage: React.FC = () => {
  const [selectedNote, setSelectedNote] = useState<Note | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // to force NoteNavigation refresh
  const navigate = useNavigate();
  // Temporary userId for testing
  const userId = 'test-user-123';

  const handleCreateNote = () => {
    navigate('/create-note');
  };

  const handleEdit = (note: Note) => {
    setIsEditing(true);
  };

  const handleDelete = async (note: Note) => {
    if (!note.id) return;
    await noteService.deleteNote(note.id);
    setSelectedNote(null);
    setIsEditing(false);
    setRefreshKey((k) => k + 1); // refresh navigation
  };

  const handleNoteUpdated = () => {
    setIsEditing(false);
    setRefreshKey((k) => k + 1);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  return (
    <div className="page-container">
      <Header />
      <div className="main-content">
        <div className="notes-layout">
          <NoteNavigation userId={userId} onNoteSelect={(note) => { setSelectedNote(note); setIsEditing(false); }} key={refreshKey} />
          <div className="notes-layout__main">
            <div className="notes-layout__header">
              <Button onClick={handleCreateNote}>Create New Note</Button>
            </div>
            {isEditing && selectedNote ? (
              <EditNoteForm
                note={selectedNote}
                onNoteUpdated={handleNoteUpdated}
                onCancel={handleCancelEdit}
              />
            ) : (
              <NoteDisplay
                note={selectedNote}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 